import { BrowserRouter, useLocation } from 'react-router-dom';
import { useEffect, useRef } from 'react';
import { AppRoutes } from './router';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import { WishlistProvider } from './context/WishlistContext';
import { ReviewProvider } from './context/ReviewContext';
import RedirectHandler from './components/feature/RedirectHandler';
import ScrollToTop from './components/feature/ScrollToTop';
import { gaPageView } from './utils/analytics';
import { CONSENT_EVENT, syncAnalyticsPrivacy } from './utils/analyticsConsent';
import LocaleController from './i18n/LocaleController';

/** Dispara gaPageView en cada cambio de ruta */
function RouteChangeTracker() {
  const location = useLocation();
  const lastViewed = useRef('');
  useEffect(() => {
    lastViewed.current = '';
    syncAnalyticsPrivacy();
    const route = location.pathname + location.search;
    const track = () => {
      if (lastViewed.current !== route && gaPageView(location.pathname, document.title)) {
        lastViewed.current = route;
      }
    };
    window.addEventListener('solsazon:page-ready', track);
    window.addEventListener(CONSENT_EVENT, track);
    return () => {
      window.removeEventListener('solsazon:page-ready', track);
      window.removeEventListener(CONSENT_EVENT, track);
    };
  }, [location.pathname, location.search]);
  return null;
}

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <LocaleController />
      <AuthProvider>
        <CartProvider>
          <WishlistProvider>
            <ReviewProvider>
              <RouteChangeTracker />
              <ScrollToTop />
              <RedirectHandler />
              <AppRoutes />
            </ReviewProvider>
          </WishlistProvider>
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
